import { useEffect, useState } from 'react';
import { toast } from '../../../../core/components/atoms/Toast';
import useUserMemory from '../use-user-memory';
import { tagService } from '../../queries/tag';

export const enum TAG_TYPE {
  DISCIPLINA = 'DISCIPLINA',
  MODULO = 'MODULO',
  ASSUNTO = 'ASSUNTO',
  AREA_PROVA = 'AREA_PROVA',
}

const useTag = (uuid?: string) => {
  const { memoryUserUuid } = useUserMemory();
  const userUuid = memoryUserUuid;

  const [tag, setTag] = useState<Tag>();
  const [isLoading, setIsLoading] = useState(false);

  const fetchTag = async (uuid: string) => {
    if (!userUuid) return;

    try {
      setIsLoading(true);
      const tag = await tagService.get(userUuid, uuid);
      setTag(tag);
    } catch (error) {
      console.error(error);
      toast({
        title: 'Erro ao buscar tags',
        message: 'Tente novamente mais tarde',
        variant: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!uuid || !userUuid) return;

    fetchTag(uuid);
  }, [userUuid, uuid]);

  return {
    tag,
    fetchTag,
    isLoading,
  };
};

export default useTag;
